// extracted by mini-css-extract-plugin
export default {"metadata":"styles__metadata___lTT5v","label":"styles__label___Vb0cL"};